var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'collapse-config',
    { 'collapse-config--opened': _vm.opened },
    { '--small': _vm.small }
  ],style:(("height: " + _vm.height + ";"))},[_c('header',{staticClass:"collapse-config__header",on:{"click":function($event){return _vm.$emit('header-click')}}},[_c('span',{class:[
        'collapse-config__title',
        {
          '--unsaved': _vm.unsaved && !_vm.opened
        }
      ]},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"collapse-config__arrow"},[(_vm.unsaved && !_vm.opened)?_c('div',{staticClass:"collapse-config__unsaved"},[_c('p',[_vm._v(_vm._s(_vm.$t((_vm.tPrefix + ".unsaved"))))])]):_vm._e(),_c('span',[_c('ArrowDownIcon',{attrs:{"width":"12","height":"8","fill":_vm.opened ? '#3E24D6' : '#405F7A'}})],1)])]),_c('div',{staticClass:"collapse-config__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }